
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { HeartHandshake } from "lucide-react";

interface PrayerRequest {
  id: number;
  title: string;
  content: string;
  user_id: string;
  created_at: string;
  is_anonymous: boolean;
}

interface CongregationPrayerRequestsProps {
  prayerRequests: PrayerRequest[];
  loadingPrayers: boolean;
  congregationName: string;
}

export function CongregationPrayerRequests({
  prayerRequests,
  loadingPrayers,
  congregationName,
}: CongregationPrayerRequestsProps) {
  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle className="flex items-center">
          <HeartHandshake className="mr-2 h-5 w-5 text-red-500" />
          Congregation Prayer Requests
        </CardTitle>
        <CardDescription>
          Recent prayer requests from {congregationName} members
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loadingPrayers ? (
          <div className="flex justify-center py-6">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"></div>
          </div>
        ) : prayerRequests.length === 0 ? (
          <p className="text-center py-4 text-gray-500">No prayer requests from this congregation yet.</p>
        ) : (
          <div className="space-y-4">
            {prayerRequests.map((prayer) => (
              <Card key={prayer.id} className="bg-gray-50 hover:bg-gray-100 transition-colors">
                <CardContent className="p-4">
                  <h3 className="font-medium text-gray-900">{prayer.title}</h3>
                  <p className="text-gray-600 text-sm my-2">{prayer.content}</p>
                  <div className="flex justify-between text-xs text-gray-500 mt-2">
                    <span>{prayer.is_anonymous ? 'Anonymous' : 'Member'}</span>
                    <span>{new Date(prayer.created_at).toLocaleDateString()}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
